export const CHANGE_USER = 'CHANGE_USER';
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';

export function changeName(name) {
	return dispatch => {
		dispatch({
			type: CHANGE_USER,
			name
		});
	};
}

export function setUserSettingState(data) {
	return async dispatch => {
		dispatch({
			type: SET_USER_SETTINGS,
			data
		});
	};
}
